import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Operador} from "../clases/Operador";
import {CondicionesService} from "../condiciones.service";
import {EncuestaDTO} from "@DTOS";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {Subscription} from "rxjs";
import {Condicion} from "../clases/Condicion";
import {take} from "rxjs/operators";
import {TipoOperadorEnum} from "@shared/enums";
import {ItemPreguntaModelDTO, PreguntaModelDTO} from "@Models";


@Component({
    selector: "app-operador",
    templateUrl: "./operador.component.html",
    styleUrls: ["./operador.component.scss"]
})
export class OperadorComponent implements OnInit, OnDestroy {
    @Input() public operador: Operador;
    @Input() public encuesta: EncuestaDTO;
    @Input() public pregunta: PreguntaModelDTO;
    @Input() public item: ItemPreguntaModelDTO;

    public operadores: Operador[] = [];
    public condiciones: Condicion[] = [];

    public TipoOperadorEnum = TipoOperadorEnum;

    public borrarOperandoCmd: ICommand = new CommandAsync(() => this.borrar());

    private subs = new Subscription();

    constructor(private condicionesService: CondicionesService) {}

    ngOnInit() {
        this.subs.add(
            this.condicionesService.operadores$.subscribe(operadores => {
                this.operadores = operadores;
            })
        );
        this.subs.add(
            this.condicionesService.condiciones$.subscribe(condiciones => {
                this.condiciones = condiciones;
            })
        );
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    public agregarOperador(operadorPrototipo: Operador) {
        const clon = operadorPrototipo.clone();
        console.log(this.operador.operadores);
        this.subs.add(
            clon.borrar$.pipe(take(1)).subscribe(() => {
                this.operador.operadores = this.operador.operadores.filter(operador => operador !== clon);
            })
        );
        this.operador.operadores.push(clon);
    }

    public agregarCondicion(condicionPrototipo: Condicion) {
        const clon = condicionPrototipo.clone();
        this.subs.add(
            clon.borrar$.pipe(take(1)).subscribe(() => {
                this.operador.condiciones = this.operador.condiciones.filter(condicion => condicion !== clon);
            })
        );
        this.operador.condiciones.push(clon);
    }

    private async borrar() {
        this.operador.borrar();
    }
}
